import { ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

const UNAVAILABLE_REASONS = {
  invalid_campaign: 'This row does not have a platform campaign ID.',
  account_unavailable: 'The ad account ID has not been synced for this campaign yet.',
  google_context_unavailable: 'Save this account’s Google Ads page URL in Ads Creator resource mapping first.',
  unavailable: 'The platform link is temporarily unavailable. Please refresh and try again.',
}

const CampaignPlatformLink = ({ campaign, compact = false }) => {
  const link = campaign?.platformLink
  if (!link) return null

  const platformName = link.platform === 'meta_ads' ? 'Meta Ads' : 'Google Ads'
  const label = `Open in ${platformName}`
  const description = link.url ? `${label} (new tab)` : UNAVAILABLE_REASONS[link.unavailableReason]
  const content = <><ExternalLink className="h-4 w-4 shrink-0" aria-hidden="true" />{!compact && <span>{platformName}</span>}</>

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex shrink-0" tabIndex={link.url ? undefined : 0} aria-label={link.url ? undefined : `${label}: ${description}`}>
            <Button
              asChild={Boolean(link.url)}
              variant={compact ? 'ghost' : 'outline'}
              size="sm"
              className={compact ? 'h-7 w-7 p-0 text-muted-foreground hover:text-primary' : 'gap-2'}
              disabled={!link.url}
              aria-label={description}
            >
              {link.url ? (
                <a href={link.url} target="_blank" rel="noopener noreferrer" onClick={event => event.stopPropagation()}>
                  {content}
                </a>
              ) : content}
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent>{description}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default CampaignPlatformLink
